(function () {
  var config = window.PALACIO_AI_ASSISTANT || {};
  var endpoint = String(config.endpoint || "").trim();
  var whatsapp = String(config.whatsapp || "5513996161750").replace(/\D/g, "");
  var root = document.querySelector("[data-pp-ai-chat]");
  if (!root || root.dataset.ready === "true") return;
  root.dataset.ready = "true";

  var toggle = root.querySelector("[data-pp-ai-toggle]");
  var close = root.querySelector("[data-pp-ai-close]");
  var form = root.querySelector("[data-pp-ai-form]");
  var input = root.querySelector("[data-pp-ai-input]");
  var messages = root.querySelector("[data-pp-ai-messages]");
  var quickButtons = root.querySelectorAll("[data-pp-ai-quick]");
  var humanLink = root.querySelector("[data-pp-ai-human]");
  var history = [];
  var busy = false;

  var welcome =
    "Ola, eu sou o assistente da Palacio Parfum. Posso ajudar voce a escolher um perfume, explicar o brinde 2ml, falar sobre presentes ou chamar um atendente humano.";

  function openChat() {
    root.classList.add("is-open");
    if (input) window.setTimeout(function () { input.focus(); }, 120);
  }

  function closeChat() {
    root.classList.remove("is-open");
  }

  function escapeText(text) {
    return String(text || "").replace(/[&<>"']/g, function (char) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }[char];
    });
  }

  function addMessage(role, text, extraClass) {
    var item = document.createElement("div");
    item.className = "pp-ai-chat__message pp-ai-chat__message--" + role + (extraClass ? " " + extraClass : "");
    item.innerHTML = escapeText(text);
    messages.appendChild(item);
    messages.scrollTop = messages.scrollHeight;
    return item;
  }

  function addTyping() {
    var item = document.createElement("div");
    item.className = "pp-ai-chat__message pp-ai-chat__message--assistant";
    item.innerHTML = '<span class="pp-ai-chat__typing"><i></i><i></i><i></i></span>';
    messages.appendChild(item);
    messages.scrollTop = messages.scrollHeight;
    return item;
  }

  function pageContext() {
    var title = document.querySelector("h1") ? document.querySelector("h1").textContent.trim() : document.title;
    var price = document.querySelector("[data-pp-price] strong") || document.querySelector(".price-item--sale");
    var priceText = price ? price.textContent.trim() : "";
    return {
      url: window.location.origin + window.location.pathname,
      title: title,
      price: priceText,
      template: document.querySelector("main") ? document.querySelector("main").dataset.template : ""
    };
  }

  function humanUrl(reason) {
    var transcript = history
      .slice(-6)
      .map(function (msg) {
        return (msg.role === "user" ? "Cliente: " : "Assistente: ") + msg.content;
      })
      .join("\n");
    var text =
      "Ola, vim pelo site da Palacio Parfum e gostaria de ajuda humana.\n\n" +
      (reason ? "Motivo: " + reason + "\n\n" : "") +
      "Pagina: " + window.location.origin + window.location.pathname +
      (transcript ? "\n\nConversa:\n" + transcript : "");

    return "https://wa.me/" + whatsapp + "?text=" + encodeURIComponent(text);
  }

  function updateHumanLink(reason) {
    if (!humanLink) return;
    humanLink.href = humanUrl(reason || "Atendimento solicitado pelo cliente");
  }

  function wantsHuman(text) {
    return /humano|atendente|whats|zap|wpp|pessoa|vendedor|suporte/i.test(text || "");
  }

  function containsSensitiveData(text) {
    var value = String(text || "");
    var digits = value.replace(/\D/g, "");
    var mentionsSecret = /\b(senha|password|cvv|cvc|token|codigo de seguranca|código de segurança)\b/i.test(value);
    var looksLikeCard = digits.length >= 13 && digits.length <= 19;
    var looksLikeCpfOrCnpj = digits.length === 11 || digits.length === 14;
    return mentionsSecret || looksLikeCard || looksLikeCpfOrCnpj;
  }

  function localAnswer(text) {
    var lower = String(text || "").toLowerCase();
    var context = pageContext();
    var answer =
      "Posso te ajudar a escolher. Me diga se voce prefere algo doce, floral, fresco, intenso ou amadeirado. Se quiser uma resposta rapida, tambem posso separar opcoes para dia a dia, noite ou presente.";

    if (/brinde|amostra|2ml/.test(lower)) {
      answer =
        "O brinde 2ml acompanha o pedido. Na pagina do produto voce escolhe a fragrancia da amostra, e ela aparece no carrinho junto com o item comprado.";
    } else if (/femin|mulher|ela|presente.*mulher/.test(lower)) {
      answer =
        "Para feminino, eu iria por tres caminhos da Palacio: La Rive Charisme para algo elegante e sofisticado, La Rive Saffira para um floral frutal facil de agradar, ou La Rive Miss Dream Pink para um lado doce e romantico. Qual estilo combina mais: delicado, doce ou marcante?";
    } else if (/mascul|homem|ele|presente.*homem/.test(lower)) {
      answer =
        "Para masculino seguro, eu separaria La Rive Steel Essence para rotina e frescor, ou La Rive Heroic Man para uma presenca mais amadeirada e marcante. Se for presente, ele prefere perfume discreto ou mais intenso?";
    } else if (/doce|adocicado|gourmand/.test(lower)) {
      answer =
        "Se voce quer um perfume mais doce e presente, olhe primeiro La Rive Cute Woman e La Rive Miss Dream Pink. Eles passam uma sensacao jovem, charmosa e envolvente sem perder o luxo acessivel da Palacio.";
    } else if (/fresco|leve|calor|dia a dia|diario/.test(lower)) {
      answer =
        "Para algo fresco e facil de usar, La Rive Steel Essence, La Rive Saffira e La Rive Donna fazem mais sentido. Combinam com calor, rotina e quem quer elegancia sem pesar.";
    } else if (/noite|balada|evento|marcante|intenso/.test(lower)) {
      answer =
        "Para noite e presenca, eu escolheria La Rive Charisme ou La Rive Isabel no feminino; La Rive Heroic Man no masculino. Sao escolhas com mais impacto e memoria.";
    } else if (/original|lacrado|confi/.test(lower)) {
      answer =
        "Sim, a proposta da Palacio Parfum e trabalhar com perfumes originais, novos e lacrados, com atendimento proximo e experiencia premium do site ate a entrega.";
    } else if (/quiz|escolher|indica|recomenda/.test(lower)) {
      answer =
        "Se voce estiver em duvida, o caminho mais rapido e fazer o Quiz Palacio. Mas eu tambem posso te indicar por aqui: voce quer feminino ou masculino, e prefere algo fresco, doce, elegante ou marcante?";
    } else if (/pre[cç]o|valor|quanto custa/.test(lower) && context.price) {
      answer =
        "Nesta pagina, o preco visivel esta como " + context.price + ". O valor final e as opcoes de pagamento devem ser conferidos no carrinho ou checkout.";
    } else if (wantsHuman(lower)) {
      answer =
        "Claro. Vou deixar o atendimento humano pronto no WhatsApp para continuar com voce e tirar qualquer duvida especifica.";
    }

    return {
      answer: answer,
      handoff: wantsHuman(lower),
      handoff_reason: wantsHuman(lower) ? "Cliente pediu atendimento humano." : "",
      quick_replies: ["Feminino", "Masculino", "Para presente", "Brinde 2ml"]
    };
  }

  async function askBackend(text) {
    if (!endpoint) return localAnswer(text);

    var controller = "AbortController" in window ? new AbortController() : null;
    var timeout = controller
      ? window.setTimeout(function () {
          controller.abort();
        }, 12000)
      : null;

    try {
      var response = await fetch(endpoint, {
        method: "POST",
        mode: "cors",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        signal: controller ? controller.signal : undefined,
        body: JSON.stringify({
          message: text,
          history: history.slice(-8),
          context: pageContext()
        })
      });

      if (!response.ok) throw new Error("Falha no atendimento automatico.");
      return response.json();
    } finally {
      if (timeout) window.clearTimeout(timeout);
    }
  }

  function renderQuickReplies(replies) {
    var container = root.querySelector("[data-pp-ai-quick-list]");
    if (!container || !Array.isArray(replies) || !replies.length) return;
    container.innerHTML = "";
    replies.slice(0, 4).forEach(function (reply) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.dataset.ppAiQuick = reply;
      btn.textContent = reply;
      btn.addEventListener("click", function () {
        submitMessage(reply);
      });
      container.appendChild(btn);
    });
  }

  async function submitMessage(text) {
    text = String(text || "").trim();
    if (!text || busy) return;
    if (containsSensitiveData(text)) {
      addMessage(
        "assistant",
        "Por segurança, não envie senhas, CPF, CNPJ, números de cartão ou códigos. Para tratar dados de um pedido, use o atendimento humano no WhatsApp."
      );
      updateHumanLink("Cliente precisa de atendimento seguro para dados pessoais ou de pedido.");
      if (humanLink) humanLink.hidden = false;
      if (input) input.value = "";
      return;
    }
    busy = true;
    addMessage("user", text);
    history.push({ role: "user", content: text });
    if (input) input.value = "";

    var typing = addTyping();
    try {
      var data = await askBackend(text);
      typing.remove();
      var answer = data.answer || "Consegui entender sua duvida. Me conte um pouco mais para eu te ajudar melhor.";
      addMessage("assistant", answer);
      history.push({ role: "assistant", content: answer });
      renderQuickReplies(data.quick_replies);
      updateHumanLink(data.handoff_reason || text);

      if (humanLink && (data.handoff || wantsHuman(text))) {
        humanLink.hidden = false;
        humanLink.focus({ preventScroll: true });
      }
    } catch (error) {
      typing.remove();
      var fallback = localAnswer(text);
      addMessage("assistant", fallback.answer + "\n\nSe preferir, posso chamar o atendimento humano no WhatsApp.", "pp-ai-chat__error");
      history.push({ role: "assistant", content: fallback.answer });
      updateHumanLink("Falha temporaria da IA. Cliente precisa de suporte.");
      if (humanLink) humanLink.hidden = false;
    } finally {
      busy = false;
    }
  }

  if (toggle) toggle.addEventListener("click", openChat);
  if (close) close.addEventListener("click", closeChat);
  if (form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      submitMessage(input.value);
    });
  }

  quickButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      submitMessage(button.dataset.ppAiQuick || button.textContent);
    });
  });

  if (input) {
    input.addEventListener("keydown", function (event) {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault();
        form.dispatchEvent(new Event("submit", { cancelable: true }));
      }
    });
  }

  addMessage("assistant", welcome);
  history.push({ role: "assistant", content: welcome });
  updateHumanLink("Atendimento solicitado pelo chat de IA");
})();
